<template>
  <div class="system-checkout-payment">
    <el-card class="box-card">
      <div class="text item">
        <el-form ref="form" :model="search" label-width="150px" label-position="left">
          <el-form-item :label="$t('system.mch_order_id')" prop="mch_order_id" required>
            <el-input v-model="search.mch_order_id" size="small" :placeholder="$t('system.mch_order_id')"
                      class="search-frame" autocomplete="off" clearable/>
          </el-form-item>
          <el-form-item :label="$t('merchantAccount.transaction_status')" prop="transaction_status" required>
            <el-select v-model="search.transaction_status" class="search-frame" size="small" clearable>
              <el-option
                v-for="(item,index) in payTransactionStatusArr"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('system.channel_code')" prop="channel_code">
            <el-input v-model="search.channel_code" size="small" :placeholder="$t('system.channel_code')" class="search-frame" autocomplete="off" clearable />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :disabled="listLoading" @click="onSubmit('form')">Submit</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { simulationCheckoutPayment } from '@/api/system/system'
import { simulatePayTransactionStatusMap } from "@/utils/maps";

export default {
  name: 'System_simulation_checkout_payment',
  data() {
    return {
      listLoading: false,
      search: {
        mch_order_id: '',
        transaction_status: '',
        channel_code: ''
      }
    }
  },
  computed: {
    payTransactionStatusArr() {
      return simulatePayTransactionStatusMap()
    },
  },
  mounted() {

  },
  methods: {
    onSubmit(formName) {
      this.listLoading = true
      simulationCheckoutPayment(this.search).then(res => {
        if (res.code === 10000) {
          this.$message.success('Success')
          this.search.amount = 0
        }
      }).finally(() => {
        this.listLoading = false
      })
    }
  }
}
</script>

<style scoped>
.search-frame {
  width: 300px;
}

.system-checkout-payment {
  margin: 20px;
  background-color: #fff;
}
</style>
